module.exports = __webpack_public_path__ + "img/app-pay-shop.8b01059c.png";